const heading = "_j0jhajey78";
const grid = "_j0jg1y4ckdk";

export { grid, heading };
import "./printer.to-paper.style.linaria.module.css";
//# sourceMappingURL=printer.to-paper.style.js.map
